<template>
	<form class="space-y-6 mb-6">
		<tw-input
			@input="() => errorMsg = ''"
			v-model="song.songName"
			class="text-md"
			id="songName"
			:label="t('customSongModal.songName')"
			required />
		<tw-input
			@input="() => errorMsg = ''"
			v-model="song.artist"
			class="text-md"
			id="artist"
			:label="t('customSongModal.artist')"
			required />
		<tw-input
			@input="() => errorMsg = ''"
			v-model="song.album"
			class="text-md"
			id="album"
			:label="t('customSongModal.album')"
			required />	
		<tw-input
			@input="() => errorMsg = ''"
			v-model="song.track"
			class="text-md"
			id="track"
			:label="t('customSongModal.track')"
			required />
	</form>

	<div 
		v-show="errorMsg" 
		class="text-red-500 mt-3 col-span-2 text-center mb-3">
		<p>{{ errorMsg }}</p>
	</div>

	<div class="flex-col-reverse flex sm:flex-row sm:items-center gap-4 justify-between">
		<tw-button
			@click="cancel"
			class="w-full ">
			{{ t('songSelection.cancel') }}
		</tw-button>
		<tw-button
			@click="save"
			class="w-full btn-brand">
			{{ t('songSelection.save') }}
		</tw-button>
	</div>
</template>

<script lang="ts">
	export default { name: 'CustomSongCard' } // name the component
</script>

<script lang="ts" setup>
	import {
		Notification
	} from '@/types'

	// Language
	import {
		useI18n
	} from 'vue-i18n'

	// Types
	import type {
		CustomSong
	} from '@/types'

	// Vue
	import {
		ref
	} from 'vue'
	
	const {t} = useI18n()

	const emit = defineEmits([
		'closeModal',
		'saveCustomSong'
	])

	const song = ref<CustomSong>({} as CustomSong)
	const errorMsg = ref('')

	function cancel() {
		emit('closeModal')
	}

	function save() {
		if(!validate()) {
			errorMsg.value = t('customSongModal.errorMsg')
			return
		}
		
		emit('saveCustomSong', song.value)
	}

	function validate() {
		if(!song.value.album?.length) return false
		else if(!song.value.artist?.length) return false
		else if(!song.value.songName?.length) return false
		else if(!song.value.track) return false

		return true
	}

</script>